import React from "react";
import "./account.css";

const HERO_IMAGE = "/images/hero-evaluation.jpg";

export default function AccountShell({
  eyebrow = "Account",
  title,
  lead,
  children,
}) {
  return (
    <div className="pi-account-page">
      <header className="pi-inner-hero">
        <div className="pi-inner-hero__media" aria-hidden>
          <img
            className="pi-inner-hero__media-img"
            src={`${process.env.PUBLIC_URL}${HERO_IMAGE}`}
            alt=""
          />
          <div className="pi-inner-hero__media-shade" />
        </div>
        <div className="pi-inner-hero__fx" aria-hidden>
          <div className="pi-inner-hero__glow pi-inner-hero__glow--a" />
          <div className="pi-inner-hero__glow pi-inner-hero__glow--b" />
          <div className="pi-inner-hero__grid" />
        </div>
        <div className="pi-inner-hero__content">
          <div className="pi-inner-hero__copy">
            <p className="pi-inner-hero__label">{eyebrow}</p>
            <h1 className="pi-inner-hero__title">{title}</h1>
            {lead ? <p className="pi-inner-hero__lead">{lead}</p> : null}
          </div>
        </div>
        <span className="pi-inner-hero__fade" aria-hidden />
      </header>
      <section className="pi-account-page__body">
        <div className="pi-account-page__panel">{children}</div>
      </section>
    </div>
  );
}
